module.exports = __webpack_public_path__ + "media/assets/kyron_avatar-67be25528e5d25cf33b189ff291365a7.svg";